export default "__VITE_ASSET__DFB0p946__"